import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'Dashboard',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
